import $ from 'jquery';

// import cookieConsent from 'cookieconsent';
// import cookieConsentCss from 'cookieconsent/build/cookieconsent.min.css';

//import aos from 'aos';
//import aosCss from 'aos/dist/aos.css';

import navigationToggle from './navigationToggle';
import mainNavigation from './mainNavigation';
import productNavigation from './productNavigation';
import bodyScrollClass from './bodyScrollClass';
import introCarousel from './introCarousel';
import productTeaserList from './productTeaserList';
import table from './table';
import productImagesPreviews from './productImagesPreviews';
import NewsCarousel from './newsCarousel';

window.$ = $;
window.jQuery = $;

document.addEventListener('DOMContentLoaded', event => {
  navigationToggle();
  mainNavigation();
  productNavigation();
  bodyScrollClass();
  table();
  introCarousel();
  productTeaserList();
  productImagesPreviews();


  $('.news-carousel').each((index, element) => {
    new NewsCarousel($(element));
  });

//  aos.init();
});
